import Auth from '../auth/Auth';
import DefaultAirport from "../models/DefaultAirport";
import { WebClient } from './WebClient'

class ApiDefaultAirport extends WebClient {
    async getDefaultAirports(): Promise<DefaultAirport[]> {
        const url = "/airport/default";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateDefaultAirport(data: DefaultAirport): Promise<DefaultAirport> {
        return this.post("/airport/default", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async deleteDefaultAirport(code: string): Promise<boolean> {
        return this.delete(`/airport/default/${code}`, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }

    async rebuildAirports(): Promise<boolean> {
        const url = "/airport/rebuild";

        return this.get(url, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch(() => { return false; });
    }
    
    async getDefaultBases(): Promise<DefaultAirport[]> {
        const url = "/airport/defaultbase";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }
}

export default new ApiDefaultAirport();
